export default __webpack_public_path__ + "static/media/Print-01.2d5f959e.svg";